import { Draft, PayloadAction } from '@reduxjs/toolkit';

import IAccountEditRequestBody from 'services/httpClient/requests/account/IAccountEditRequestBody';

import { IAuthData } from '../../initialState';

function editSuccess(
  draft: Draft<IAuthData>,
  action: PayloadAction<IAccountEditRequestBody>,
) {
  draft.edit.config.isLoading = false;
  draft.profile.email = action.payload.email;
  draft.profile.firstname = action.payload.firstname;
  draft.profile.lastname = action.payload.lastname;
  draft.profile.mobile_phone = action.payload.mobile_phone;
  draft.profile.phone = action.payload.phone;
  draft.profile.locale = action.payload.locale;
  draft.profile.iban = action.payload.iban;
}

export default editSuccess;
